module.exports = __webpack_public_path__ + "static/media/hapi.cc02a01e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/hapi.png
// module id = 111
// module chunks = 0